<template>
  <div>

    <!--提醒-->
    <div>
      <remind word="建议上传的图片宽高比为 12:7"/>
    </div>

    <div class="header">
      <el-row>
        <!--title-->
        <el-col :offset="3" :span="1" class="title">{{$t('messages.题目')}}:</el-col>
        <el-col :span="6">
          <el-input v-model="title" :placeholder="$t('upload.请输入标题,只允许输入一段文字,段落中及段落后不允许按换行(enter)键')" class="titleInput" type="textarea" :rows="3" maxlength="100"
                    show-word-limit/>
        </el-col>
        <!--titleEn-->
        <el-col :offset="1" :span="4">
          <el-input v-model="titleEn" class="titleInput" type="textarea" :rows="3" maxlength="800"
                    show-word-limit/>
        </el-col>
        <!--isTop3-->
        <el-col :offset="1" :span="4" class="isTop3">
          <div>
            <el-radio v-model="radio" label="1" size="large">{{$t('messages.置为Top3')}}</el-radio>
            <el-radio v-model="radio" label="0" size="large">{{$t('messages.不置为Top3')}}</el-radio>
          </div>
        </el-col>

      </el-row>
    </div>

    <div class="main">
      <update-research ref="update1" @uploadSuccess="uploadSuccess1" :uploadURL="uploadURL"></update-research>
      <update-research ref="update2" @uploadSuccess="uploadSuccess2" :uploadURL="uploadURL"></update-research>
      <update-research ref="update3" @uploadSuccess="uploadSuccess3" :uploadURL="uploadURL"></update-research>
      <update-research ref="update4" @uploadSuccess="uploadSuccess4" :uploadURL="uploadURL"></update-research>
      <update-research ref="update5" @uploadSuccess="uploadSuccess5" :uploadURL="uploadURL"></update-research>
      <update-research ref="update6" @uploadSuccess="uploadSuccess6" :uploadURL="uploadURL"></update-research>
    </div>

    <div class="foot">
      <el-button class="upload" size="large" type="success" @click="submitInfo">{{$t('messages.上传')}}</el-button>
    </div>

    <div class="research">
      <research-item :researches="researchData" @delHide="delSlot = false" @delShow="delSlot = true" >
        <template v-slot:delSlot="slotValue">
          <!--{{slotValue.data}}-->
          <el-button v-if="delSlot" class="del" type="success" @click="deleteRea(slotValue.data)">{{$t('messages.删除')}}</el-button>
        </template>
      </research-item>

      <pagination ref="paging" @pagingChange="pagingChange" :total="count"></pagination>
    </div>

  </div>

  <Animate ref="animate" />
</template>

<script>

  import {ref, reactive, getCurrentInstance, onMounted} from 'vue'
  import { useStore } from 'vuex'
  import {ElMessage, ElMessageBox} from 'element-plus'
  import { useI18n } from 'vue-i18n'//要在js中使用国际化

  import UpdateResearch from "../../childComps/UpdateResearch";
  import ResearchItem from "@/views//research/childComps/ResearchItem";
  import Pagination from "@/components/common/Pagination";
  import Remind from "@/components/common/Remind";
  import Animate from "@/components/common/Animate";

  import {insertResearch} from "@/network/research";
  import { fy } from '@/network/utils'
  import { delResearch, totalResearch, queryResearch, queryImg1 } from '@/network/research'

  export default {
    name: "NewResearch",
    components: {
      UpdateResearch,
      ResearchItem,
      Pagination,
      Remind,
      Animate,
    },
    setup() {

      //data
      let instance = reactive({});
      instance = getCurrentInstance();
      const store = useStore();
      // t 引用i18n
      const { t } = useI18n()
      //科研信息
      let researchData = reactive([]);
      //let update1 = ref('');
      let title = ref('');
      let titleEn = ref('');
      let radio = ref('0');
      // 图片上传地址
      let uploadURL = ref(store.state.uploadAddr + '/research/insert');

      let word1 = ref('');
      let word1En = ref('');
      let note1 = ref('');
      let note1En = ref('');
      let word2 = ref('');
      let word2En = ref('');
      let note2 = ref('');
      let note2En = ref('');
      let word3 = ref('');
      let word3En = ref('');
      let note3 = ref('');
      let note3En = ref('');
      let word4 = ref('');
      let word4En = ref('');
      let note4 = ref('');
      let note4En = ref('');
      let word5 = ref('');
      let word5En = ref('');
      let note5 = ref('');
      let note5En = ref('');
      let word6 = ref('');
      let word6En = ref('');
      let note6 = ref('');
      let note6En = ref('');
      // imgLength
      let imgLength = ref(0);
      // inputLength
      let inputLength = ref(0);
      //是否显示delSlot
      let delSlot = ref(false);
      // 科研信息的总数量
      let count = ref(0);


      onMounted(() => {
        totalResearch().then(res => {
          if (res.state === 200){
            count.value = res.data;                                 //用props传参不好用,不知道为啥
            instance.proxy.$refs.paging.pagination.total = res.data;  //这个方案好用
          }
        })

        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      });

      /* 01 -> 6   23 -> 5   45 -> 4   67 -> 3   89 -> 2   1011 -> 1
      * 1.中间有空行
      * 2.没图片但有图标描述(其他)
      * 3.按照'文字信息 图片 图片下标'形式,最后一段可以没图片
      * */

      // 校验input是否合规
      function checkForm(){
        if (title.value.trim().length === 0){
          ElMessage.error('messages.标题不能为空')
          return false
        }
        let inputArr = reactive([
          {value: note6.value}, {value: word6.value}, {value: note5.value}, {value: word5.value}, {value: note4.value}, {value: word4.value},
          {value: note3.value}, {value: word3.value}, {value: note2.value}, {value: word2.value}, {value: note1.value}, {value: word1.value},
        ])
        let inputFlag = true
        for (let i = 0; i < 12; i++) {
          if (inputArr[i].value.trim().length > 0 && inputFlag === true){
            inputLength.value = Math.ceil((12 - i) / 2)
            inputFlag = false
          } else if (inputFlag === false){
            if (inputArr[i].value.trim().length === 0){
              ElMessage.error(t('messages.科研信息中的段落文字或图片描述文字不能为空'))
              return false
            }
          }
        }//for
        return true;
      }
      // 校验upload是否合规
      function checkUpload(){
        if (!((inputLength.value === imgLength.value) || (inputLength.value === imgLength.value + 1))){
          ElMessage.error(t('messages.图片长度不符合规定'))
          return false
        }
        let picArr = reactive([
          {value: instance.proxy.$refs.update1.fileList.length}, {value: instance.proxy.$refs.update2.fileList.length},
          {value: instance.proxy.$refs.update3.fileList.length}, {value: instance.proxy.$refs.update4.fileList.length},
          {value: instance.proxy.$refs.update5.fileList.length}, {value: instance.proxy.$refs.update6.fileList.length},
        ])
        for (let i = imgLength.value; i < 6; i++) {
          if (picArr[i].value > 0){
            ElMessage.error(t('messages.科研信息中图片不能为空'))
            return false
          }
        }//for
        return true;
      }


      //method
      // 点进页面即获取数据展示
      queryResearch(0, 20).then(res => {
        if (res.state === 200)
          res.data.forEach(item => researchData.push(item))
        else if (res.state === '50000'){
          router.push('/regLogin');
          ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
        }
      })
      // 分页变化
      function pagingChange(pageSize, currentPage) {
        let length = 0;
        researchData.length = 0;
        if ((currentPage - 1) * pageSize + pageSize > count.value)
          length = count.value - (currentPage - 1) * pageSize;
        else length = pageSize;
        queryResearch((currentPage - 1) * pageSize, length).then(res => {
          if (res.state === 200){
            res.data.forEach(item => researchData.push(item));
          } else if (res.state === '50000'){
            router.push('/regLogin');
            ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
          }
        })
      }
      // 删除
      function deleteRea(id) {
        ElMessageBox.confirm(
            t('messages.你确定要删除么?'),
            'Warning',
            {
              confirmButtonText: t('messages.确认'),
              cancelButtonText: t('messages.取消'),
              type: 'warning',
            }
        ).then(() => {
          delResearch(id).then(res => {
            if (res.state === 200)
              ElMessage.success(t('messages.删除成功'));
            else if (res.state === '50000'){
              router.push('/regLogin');
              ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
            } else {
              ElMessage.error(t('messages.删除失败'))
            }
          })
        }).catch(()=>{});

      }
      //提交
      function submitInfo() {
        //update1.value.submitUpload();
        ElMessageBox.confirm(
            t('messages.确认上传?'),
            'Warning',
            {
              confirmButtonText: t('messages.确认'),
              cancelButtonText: t('messages.取消'),
              type: 'warning',
            }
        ).then(() => {
          // 非空word数量
          let i = 0;
          // 终止函数的标志(段落中有特殊字符或者换行符则改为false 终止函数)
          let flag = ref(true);
          // words
          word1.value = instance.proxy.$refs.update1.inputWords;
          word1En.value = instance.proxy.$refs.update1.inputWordsEn;
          if(word1.value.length > 0 ) i++;
          word2.value = instance.proxy.$refs.update2.inputWords;
          word2En.value = instance.proxy.$refs.update2.inputWordsEn;
          if(word2.value.length > 0 ) i++;
          word3.value = instance.proxy.$refs.update3.inputWords;
          word3En.value = instance.proxy.$refs.update3.inputWordsEn;
          if(word3.value.length > 0 ) i++;
          word4.value = instance.proxy.$refs.update4.inputWords;
          word4En.value = instance.proxy.$refs.update4.inputWordsEn;
          if(word4.value.length > 0 ) i++;
          word5.value = instance.proxy.$refs.update5.inputWords;
          word5En.value = instance.proxy.$refs.update5.inputWordsEn;
          if(word5.value.length > 0 ) i++;
          word6.value = instance.proxy.$refs.update6.inputWords;
          word6En.value = instance.proxy.$refs.update6.inputWordsEn;
          if(word6.value.length > 0 ) i++;

          // notes
          note1.value = instance.proxy.$refs.update1.inputNotes;
          note1En.value = instance.proxy.$refs.update1.inputNotesEn;
          note2.value = instance.proxy.$refs.update2.inputNotes;
          note2En.value = instance.proxy.$refs.update2.inputNotesEn;
          note3.value = instance.proxy.$refs.update3.inputNotes;
          note3En.value = instance.proxy.$refs.update3.inputNotesEn;
          note4.value = instance.proxy.$refs.update4.inputNotes;
          note4En.value = instance.proxy.$refs.update4.inputNotesEn;
          note5.value = instance.proxy.$refs.update5.inputNotes;
          note5En.value = instance.proxy.$refs.update5.inputNotesEn;
          note6.value = instance.proxy.$refs.update6.inputNotes;
          note6En.value = instance.proxy.$refs.update6.inputNotesEn;

          // imgLength
          if (instance.proxy.$refs.update1.fileList.length !== 0)  imgLength.value++;
          if (instance.proxy.$refs.update2.fileList.length !== 0)  imgLength.value++;
          if (instance.proxy.$refs.update3.fileList.length !== 0)  imgLength.value++;
          if (instance.proxy.$refs.update4.fileList.length !== 0)  imgLength.value++;
          if (instance.proxy.$refs.update5.fileList.length !== 0)  imgLength.value++;
          if (instance.proxy.$refs.update6.fileList.length !== 0)  imgLength.value++;

          insertResearch(title.value, titleEn.value, word1.value, word1En.value, note1.value, note1En.value, word2.value, word2En.value, note2.value, note2En.value,
              word3.value, word3En.value, note3.value, note3En.value, word4.value, word4En.value, note4.value, note4En.value, word5.value, word5En.value,
              note5.value, note5En.value, word6.value, word6En.value, note6.value, note6En.value, parseInt(radio.value), localStorage.getItem('username'), imgLength.value)
              .then(res => {
                console.log('res: ', res)
                instance.proxy.$refs.update1.submitUpload();
                //console.log('继续向后执行了')
              })

          // 原来的翻译模块
          /*tijiao();
          async function tijiao() {
            // 非空word数量
            let i = 0;
            // 终止函数的标志(段落中有特殊字符或者换行符则改为false 终止函数)
            let flag = ref(true);
            // words
            word1.value = instance.proxy.$refs.update1.inputWords;
            word1En.value = instance.proxy.$refs.update1.inputWordsEn;
            if(word1.value.length > 0 ) i++;
            word2.value = instance.proxy.$refs.update2.inputWords;
            word2En.value = instance.proxy.$refs.update2.inputWordsEn;
            if(word2.value.length > 0 ) i++;
            word3.value = instance.proxy.$refs.update3.inputWords;
            word3En.value = instance.proxy.$refs.update3.inputWordsEn;
            if(word3.value.length > 0 ) i++;
            word4.value = instance.proxy.$refs.update4.inputWords;
            word4En.value = instance.proxy.$refs.update4.inputWordsEn;
            if(word4.value.length > 0 ) i++;
            word5.value = instance.proxy.$refs.update5.inputWords;
            word5En.value = instance.proxy.$refs.update5.inputWordsEn;
            if(word5.value.length > 0 ) i++;
            word6.value = instance.proxy.$refs.update6.inputWords;
            word6En.value = instance.proxy.$refs.update6.inputWordsEn;
            if(word6.value.length > 0 ) i++;
            // notes
            note1.value = instance.proxy.$refs.update1.inputNotes;
            note1En.value = instance.proxy.$refs.update1.inputNotesEn;
            note2.value = instance.proxy.$refs.update2.inputNotes;
            note2En.value = instance.proxy.$refs.update2.inputNotesEn;
            note3.value = instance.proxy.$refs.update3.inputNotes;
            note3En.value = instance.proxy.$refs.update3.inputNotesEn;
            note4.value = instance.proxy.$refs.update4.inputNotes;
            note4En.value = instance.proxy.$refs.update4.inputNotesEn;
            note5.value = instance.proxy.$refs.update5.inputNotes;
            note5En.value = instance.proxy.$refs.update5.inputNotesEn;
            note6.value = instance.proxy.$refs.update6.inputNotes;
            note6En.value = instance.proxy.$refs.update6.inputNotesEn;

            insertResearch(title.value, titleEn.value, word1.value, word1En.value, note1.value, note1En.value, word2.value, word2En.value, note2.value, note2En.value,
                word3.value, word3En.value, note3.value, note3En.value, word4.value, word4En.value, note4.value, note4En.value, word5.value, word5En.value,
                note5.value, note5En.value, word6.value, word6En.value, note6.value, note6En.value, parseInt(radio.value), localStorage.getItem('username'), imgLength.value)
                .then(res => {
                  instance.proxy.$refs.update1.submitUpload();
                  //console.log('继续向后执行了')
                })

            /!*!// 如果表单验证通过 执行翻译
            if (checkForm() === true){
              // 翻译函数
              await fy(title.value + '\n' + word1.value + '\n' + word2.value + '\n' + word3.value + '\n' + word4.value + '\n' + word5.value + '\n' + word6.value + '\n' +
                  '\n' + note1.value + '\n' + note2.value + '\n' + note3.value + '\n' + note4.value + '\n' + note5.value + '\n' + note6.value).then(res => {
                const { data } = res;
                //console.log('res:',res)
                //console.log('data:',data)
                //console.log('是否有error_code:', data.hasOwnProperty('error_code')) 如果有此属性 返回true 说明翻译出错
                if ((title.value.includes('\n')) || (word1.value.includes('\n')) || (word2.value.includes('\n')) || (word3.value.includes('\n')) ||
                    (word4.value.includes('\n')) && (word5.value.includes('\n')) && (word6.value.includes('\n')) || (note1.value.includes('\n')) ||
                    (note2.value.includes('\n')) || (note3.value.includes('\n')) || (note4.value.includes('\n')) || (note5.value.includes('\n')) || (note6.value.includes('\n'))){
                  ElMessage.error(t('upload.文本中只允许输入一段文字, 段落后不允许按换行(enter)键, 请检查后提交'))
                  // 翻译成功 flag置为true 继续执行
                  flag.value = false;
                }
                if (data.hasOwnProperty('error_code')){
                  ElMessage.error(t('upload.文本中只允许包含 中文 英文 标点符号, 请检查后提交'))
                  // 翻译成功 flag置为true 继续执行
                  flag.value = false;
                  // console.log('flag.value上面 ',flag.value)
                } else {
                  //ElMessage.success('翻译成功')
                  const { trans_result: result} = data;
                  //console.log('result: ', result)
                  // 为翻译后的字段赋值
                  //word赋值
                  titleEn.value = result[0].dst;
                  for (let j = 1; j <= i; j++) {
                    if (j === 1) word1En.value = result[j].dst;
                    if (j === 2) word2En.value = result[j].dst;
                    if (j === 3) word3En.value = result[j].dst;
                    if (j === 4) word4En.value = result[j].dst;
                    if (j === 5) word5En.value = result[j].dst;
                    if (j === 6) word6En.value = result[j].dst; // && j <= i
                  }
                  //note赋值
                  for (let k = i + 1 ; k < result.length ; k++){
                    if ((k - i) === 1) note1En.value = result[k].dst;
                    if ((k - i) === 2) note2En.value = result[k].dst;
                    if ((k - i) === 3) note3En.value = result[k].dst;
                    if ((k - i) === 4) note4En.value = result[k].dst;
                    if ((k - i) === 5) note5En.value = result[k].dst;
                    if ((k - i) === 6) note6En.value = result[k].dst; // && (k <= result.length - i)
                  }
                }
              });    //表单验证不通过,flag重新置为false,不继续向下执行
            } else { flag.value = false; }


            // 如果flag为true 继续执行
            if (flag.value){
              //console.log('flag.value ',flag.value)
              // imgLength
              if (instance.proxy.$refs.update1.fileList.length !== 0)  imgLength.value++;
              if (instance.proxy.$refs.update2.fileList.length !== 0)  imgLength.value++;
              if (instance.proxy.$refs.update3.fileList.length !== 0)  imgLength.value++;
              if (instance.proxy.$refs.update4.fileList.length !== 0)  imgLength.value++;
              if (instance.proxy.$refs.update5.fileList.length !== 0)  imgLength.value++;
              if (instance.proxy.$refs.update6.fileList.length !== 0)  imgLength.value++;
              //console.log('checkUpload(): ', checkUpload());

              // upload验证通过, 继续执行
              if (checkUpload() === true){
                insertResearch(title.value, titleEn.value, word1.value, word1En.value, note1.value, note1En.value, word2.value, word2En.value, note2.value, note2En.value,
                    word3.value, word3En.value, note3.value, note3En.value, word4.value, word4En.value, note4.value, note4En.value, word5.value, word5En.value,
                    note5.value, note5En.value, word6.value, word6En.value, note6.value, note6En.value, parseInt(radio.value), localStorage.getItem('username'), imgLength.value)
                    .then(res => {
                      instance.proxy.$refs.update1.submitUpload();
                      //console.log('继续向后执行了')
                    })
              }

            }*!/
          } // tijiao*/
        })
      }

      function uploadSuccess1() {
        instance.proxy.$refs.update2.submitUpload();
      }
      function uploadSuccess2() {
        instance.proxy.$refs.update3.submitUpload();
      }
      function uploadSuccess3() {
        instance.proxy.$refs.update4.submitUpload();
      }
      function uploadSuccess4() {
        instance.proxy.$refs.update5.submitUpload();
      }
      function uploadSuccess5() {
        instance.proxy.$refs.update6.submitUpload();
      }
      function uploadSuccess6() {}
      // 删除键显示
      function delShow() {
        console.log('delShow')
      }
      // 删除键隐藏
      function delHide() {
        console.log('delHide')
      }




      return {
        title, titleEn, radio, uploadURL, researchData, delSlot, count,
        submitInfo, uploadSuccess1, uploadSuccess2, uploadSuccess3, uploadSuccess4, uploadSuccess5, uploadSuccess6, deleteRea, delShow, delHide, pagingChange
      }
    }
  }
</script>

<style scoped lang="less">

  .header {
    padding-top: 40px;

    .title {
      font-size: 16px;
      text-align: center;
      display: flex;
      //justify-content: center;
      align-items: center;
    }

    .titleInput {
      //width: 400px;
    }

    .isTop3 {
      display: flex;
      align-items: center;
    }

    .query_del{
      display: flex;
      align-items: center;
      .query{
        //margin: 0 30px;
      }
    }
  }

  .foot {
    text-align: center;
    padding: 30px 0;

    .upload {
      width: 100px;
      font-size: 16px;
    }
  }

  .research{
    padding-bottom: 50px;

    .el-pagination{
      display: flex;
      justify-content: center;
      padding: 40px 20px 50px 0;
    }
    .del{
      position: absolute;
      top: 66px;
      right: 7%;
    }
  }
</style>